import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import WineCard from '../components/WineCard';
import { useWines } from '../context/WinesContext';
import fotoVinha2 from '../assets/foto_vinha2.jpg';
import { useT, useLanguage } from '../i18n/LanguageContext';
import { TYPE_KEYS } from '../i18n/translations';

const FILTERS = ['Todos', 'Tinto Colheita', 'Branco Colheita', 'Tinto Reserva', 'Branco Reserva'];

export default function Loja() {
  const [searchParams, setSearchParams] = useSearchParams();
  const t = useT();
  const { lang } = useLanguage();
  const { wines, loading, error, refetch } = useWines();

  // Estado derivado directamente da URL — sem useEffect/useState
  const active = searchParams.get('tipo') || 'Todos';

  const handleFilter = (f) => {
    const next = new URLSearchParams(searchParams);
    if (f === 'Todos') {
      next.delete('tipo');
    } else {
      next.set('tipo', f);
    }
    setSearchParams(next, { replace: true });
  };

  const filtered = useMemo(
    () => (active === 'Todos' ? wines : wines.filter(w => w.type === active)),
    [active, wines]
  );

  return (
    <div className="page-top">

      {/* ── Header ── */}
      <section
        className="section"
        style={{
          background: `linear-gradient(160deg, rgba(14,7,4,0.65) 0%, rgba(14,7,4,0.35) 100%), url(${fotoVinha2}) center/cover no-repeat`,
          paddingTop: 'calc(var(--nav-height) + var(--sp-16))',
        }}
      >
        <div className="container">
          <p className="t-label" style={{ color: '#ffffff', marginBottom: 'var(--sp-4)' }}>
            {t('loja.eyebrow')}
          </p>
          <h1 className="t-h1" style={{ color: '#ffffff', textTransform: 'uppercase' }}>
            {t('loja.title')}
          </h1>
          <p className="t-body-lg" style={{ color: 'rgba(255,255,255,0.7)', marginTop: 'var(--sp-4)', maxWidth: '56ch' }}>
            {t('loja.lead')}
          </p>
        </div>
      </section>

      {/* ── Filtros ── */}
      <section className="section--sm" style={{ borderBottom: 'var(--border-thin)' }}>
        <div className="container">
          <div className="flex gap-2" style={{ flexWrap: 'wrap' }}>
            {FILTERS.map(f => {
              const label = f === 'Todos'
                ? t('loja.filterAll')
                : (TYPE_KEYS[f] ? t(TYPE_KEYS[f]) : f);
              const count = f === 'Todos'
                ? wines.length
                : wines.filter(w => w.type === f).length;
              return (
                <button
                  key={f}
                  className={`tag${active === f ? ' tag--active' : ''}`}
                  onClick={() => handleFilter(f)}
                >
                  {label} <span style={{ opacity: 0.55, marginLeft: '0.25em' }}>({count})</span>
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── Grid de vinhos ── */}
      <section className="section">
        <div className="container">
          {loading ? (
            <p className="t-body-lg t-light t-center" style={{ padding: 'var(--sp-16) 0' }}>
              {t('common.loading')}
            </p>
          ) : error ? (
            <div className="t-center" style={{ padding: 'var(--sp-16) 0' }}>
              <p className="t-body-lg t-light">{t('common.error')}</p>
              <button type="button" className="btn btn-sm" style={{ marginTop: 'var(--sp-6)' }} onClick={refetch}>
                {t('common.retry')}
              </button>
            </div>
          ) : filtered.length === 0 ? (
            <p className="t-body-lg t-light t-center" style={{ padding: 'var(--sp-16) 0' }}>
              {t('loja.empty')}
            </p>
          ) : (
            <div className="grid-3">
              {filtered.map(w => (
                <WineCard key={w.id} {...w} description={lang === 'en' ? w.description.en : w.description.pt} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
